import React from 'react';
import PropTypes from 'prop-types';
import DismissButton from './DismissButton';
import {
    INSTRUCTION_CARD_CLASS,
    CONTENT_CLASS,
    CONTENT_CONTAINER_CLASS,
    FOOTER_CLASS,
    CONTENT_ICON_CLASS,
    CONTENT_ICON,
    CONTENT_TEXT_CLASS,
    CONTENT_ICON_SWIPE,
    CONTENT_TITLE_CLASS,
    CONTENT_DETAIL_CLASS,
} from './constants/constants';
import {
    SWIPER_SLIDE_CLASS_NAME,
} from '~shared/utils/swiper';

import {
    useIsMobile,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useInstructionCards,
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';

import './styles/instructionCard.scss';


const InstructionCard = (props) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    if (!isUserLoggedIn) {
        return null;
    }

    return <InstructionCardAuth {...props} />;
};

const InstructionCardAuth = ({
    contentText,
    footerText,
    titleText,
    gtmAttribute,
    type,
    pageMode,
}) => {
    const instructionCards = useInstructionCards();
    const isAvailable = instructionCards.includes(type);
    const isMobile = useIsMobile();

    if (!isAvailable) {
        return null;
    }

    const instructionFooter = () => (
    <div className={FOOTER_CLASS}>
        <span>
            {footerText}
        </span>
    </div>
    );

    const rootClass = !pageMode && SWIPER_SLIDE_CLASS_NAME;
    const iconClass = isMobile && !pageMode
        ? CONTENT_ICON_SWIPE
        : CONTENT_ICON;

    const showFooter = footerText ? instructionFooter() : '';
    const showTitle = titleText ? <span className={CONTENT_TITLE_CLASS}>{titleText}</span> : '';

    return (
        <div className={rootClass}>
            <div className={INSTRUCTION_CARD_CLASS}>
                <div className={CONTENT_CLASS}>
                    <div className={CONTENT_CONTAINER_CLASS}>
                        <div className={CONTENT_ICON_CLASS}>
                            <div className={iconClass}></div>
                        </div>
                        <div className={CONTENT_DETAIL_CLASS}>
                            {showTitle}
                            <span className={CONTENT_TEXT_CLASS}>
                                {contentText}
                            </span>
                        </div>
                    </div>
                    <DismissButton
                        gtmAttribute={gtmAttribute}
                        type={type}
                    />
                </div>
                {showFooter}
            </div>
        </div>
    );
};

InstructionCardAuth.propTypes = {
    contentText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    footerText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    titleText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    gtmAttribute: PropTypes.string,
    type: PropTypes.string.isRequired,
    pageMode: PropTypes.bool,
};

InstructionCardAuth.defaultProps = {
    contentText: '',
    footerText: '',
    titleText: '',
    gtmAttribute: '',
    pageMode: false,
};

export default InstructionCard;
